import { DateTime } from 'luxon';

import { CampaignStatus } from 'modules/campaigns/types';

export const hasCampaignStarted = ({
  campaignStatus,
  startDate,
}: {
  campaignStatus: CampaignStatus;
  startDate: string;
}) => {
  if (campaignStatus === CampaignStatus.SCHEDULED) {
    return false;
  }

  const isStartDateInFuture = startDate > DateTime.local().toISO();

  if (campaignStatus === CampaignStatus.STOPPED && isStartDateInFuture) {
    return false;
  }

  return true;
};
